export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',
    msgSetError: '[Msg] Set Errot',
    msgRemoveError: '[Msg] Set Error',
    selectedPage: 'GET_SELECTED_PAGE',
    //PAGES
    //Proccess
    getVariableControlled : 'GET_VARIABLE_CONTROLLED',
    getVariableManipulated : 'GET_VARIABLE_MANIPULATED',
    getVariableDependent : 'GET_VARIABLE_DEPENDENT',
    getDataProccess: 'GET_DATA_PROCCESS',
    
    GET_VARIABLE_CONTROLLED : 'GET_VARIABLE_CONTROLLED',
    GET_VARIABLE_MANIPULATED : 'GET_VARIABLE_MANIPULATED',
    GET_VARIABLE_DEPENDENT : 'GET_VARIABLE_DEPENDENT',
    GET_DATA_CONTROLLED : 'GET_DATA_CONTROLLED',
    GET_DATA_MANIPULATED : 'GET_DATA_CONTROLLED',
    GET_DATA_PROCCESS: 'GET_DATA_PROCCESS'

}